/* src/app/warehousing/pages/product-classes-new/product-classes-new.component.scss */
/*# sourceMappingURL=product-classes-new.component.css.map */
